import { RootState } from '@/store';
import { BUNDLE_TAG } from '../constants';
import { api, isEndpointLockError } from '../core';
import { refreshBundleSectionsWithCurrentFilters } from './getBundleSections';

export interface ClusterDateUpdateRequest {
  sectionId: string;
  bundleId: string;
  date: string;
}

export interface ClusterDateUpdateResponse {
  success: boolean;
}

export const clusterDateUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postClusterDateUpdate: builder.mutation<ClusterDateUpdateResponse, ClusterDateUpdateRequest>({
      query: ({ sectionId, bundleId, date }) => ({
        url: '/cluster/date/update',
        method: 'POST',
        body: {
          sectionId,
          bundleId,
          date,
        },
      }),
      // A lock refusal changed nothing, so reloading the bundle for it would only redraw every page
      invalidatesTags: (_result, error, { bundleId }) =>
        isEndpointLockError(error) ? [] : [{ type: BUNDLE_TAG, id: bundleId }],
      async onQueryStarted(_arg, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled;
          const state = getState() as RootState;
          refreshBundleSectionsWithCurrentFilters(dispatch, state);
        } catch (error) {
          console.error('Error in postClusterDateUpdate:', error);
        }
      },
    }),
  }),
});

export const { usePostClusterDateUpdateMutation } = clusterDateUpdateApi;
